import * as React from 'react';
import { Dots } from 'react-activity';
import API from '../../lib/BackendAPI';
import { getCurrentQueryParams } from '../../lib/queryParams';
import { IProfile } from '../../lib/types/Profile';
import ErrorMessage from '../ErrorMessage';
import UserEmailAddress from './UserEmailAddress';
import UserProfile from './UserProfile';

interface IProps {
  onLoad: () => void;
}

interface IState {
  details?: IProfile;
}

export default class EmailAndProfile extends React.Component<IProps> {
  public state: IState = {};

  public componentDidMount() {
    const idToken = getCurrentQueryParams().idToken;

    API.fetchDetails(idToken).then((details: any) => {
      this.setState({ details });
      if (this.props.onLoad && details.status !== 'error') {
        this.props.onLoad();
      }
    });
  }

  public render() {
    if (!this.state.details) {
      return <Dots size={30} />;
    }

    if (this.state.details && this.state.details.status === 'error') {
      return (
        <ErrorMessage>
          Sorry, konnte Deine Adresse nicht laden. Bitte probier’s später
          nochmal!
        </ErrorMessage>
      );
    }

    return (
      <React.Fragment>
        <section className="email-address">
          <UserEmailAddress details={this.state.details} />
          <footer>
            E-Mail falsch?{' '}
            <a href="https://profile.7pass.de/">
              In Deinem 7Pass-Profil kannst Du die Email-Adresse ändern.
            </a>
          </footer>
        </section>

        <section className="profile">
          <UserProfile details={this.state.details} />
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfirmPurchase/EmailAndProfile.tsx